export default __webpack_public_path__ + "static/media/target-10.e5304025.png";